import { useAppSelector } from 'hooks/useAppSelector';
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useOrderType } from 'routes/secondary-market-batch/hooks/use-order-type';
import { isOrderType } from 'routes/secondary-market-batch/utils';
import { getAvailableOrderTypes, getDefaultOrderType } from 'state/selectors/meta/secondary-market';
import { selectOrderType } from 'state/workspaces/secondary-market/batch/selectors';

export function useSyncOrderTypeWithUrl() {
  const { orderType: orderTypeFromUrl } = useParams();
  const { orderType: currentOrderType, setOrderType } = useOrderType();
  const currentRawOrderType = useAppSelector(selectOrderType);
  const availableOrderTypes = useAppSelector(getAvailableOrderTypes);
  const defaultOrderType = useAppSelector(getDefaultOrderType);
  const navigate = useNavigate();

  useEffect(() => {
    if (!defaultOrderType) {
      return;
    }

    const isUrlOrderTypeAllowed = isOrderType(orderTypeFromUrl) && availableOrderTypes.includes(orderTypeFromUrl);

    if (!isUrlOrderTypeAllowed) {
      if (currentRawOrderType !== currentOrderType) {
        setOrderType(currentOrderType);
      }
      navigate(`/secondary-market-batch/${currentOrderType}`, {
        replace: true,
      });
      return;
    }

    if (orderTypeFromUrl !== currentRawOrderType) {
      setOrderType(orderTypeFromUrl);
    }
  }, [
    availableOrderTypes,
    currentOrderType,
    currentRawOrderType,
    defaultOrderType,
    navigate,
    orderTypeFromUrl,
    setOrderType,
  ]);
}
